import { SLIDER_TILE_DISPLAY } from "~/hec/components/organisms/dynamic-product-tile/display-defaults";
import { FEATURED_PRODUCTS_MAX_IDS } from "~/hec/dynamic-product-tile/dynamic-product-tile.schemas";

import {
  featureContentInputs,
  productChoiceInputs,
  sliderTileDisplayInputs,
} from "../dynamic-product-tile/inputs";

/**
 * Builder inputs for `FeaturedProductSlider` (POC). Tile options are declared
 * ONCE and applied to all three tiles; each product row only carries what
 * differs per product (which product, its feature copy, an optional photo).
 */
export const featuredProductSliderInputs = [
  {
    name: "headline",
    type: "string",
    defaultValue: "Complete your routine with more exclusives",
  },
  {
    name: "products",
    friendlyName: "Products (priority order)",
    type: "list",
    // No layout-based `showIf` on these rows: inside a list row Builder does
    // not reliably expose the slider's `tileOptions.layout` (two attempts via
    // the undocumented `parent` argument hid the fields in the editor even on
    // the Feature layout). Always visible; their help text says "Feature
    // layout". The single Product Tile does hide them — its layout is a
    // top-level input that `options.get` can read.
    subFields: [...productChoiceInputs, ...featureContentInputs],
    defaultValue: [{}, {}, {}],
    helperText: `The first 3 in stock are shown. Add more rows as backups — one steps in when an earlier product is out of stock. Up to ${FEATURED_PRODUCTS_MAX_IDS} SKUs are read; later rows are ignored.`,
  },
  {
    name: "tileOptions",
    friendlyName: "Tile options (all tiles)",
    type: "object",
    subFields: sliderTileDisplayInputs,
    defaultValue: { ...SLIDER_TILE_DISPLAY },
  },
  {
    name: "background",
    friendlyName: "Background (CSS)",
    type: "string",
    defaultValue:
      "linear-gradient(180deg, rgba(176, 216, 221, 0.7) 0%, rgba(255, 255, 255, 0.7) 145.58%), #fff",
    helperText:
      "Any CSS background value — a color (#f6f6f6, rgb(...)) or a gradient. Leave empty for none.",
  },
  {
    name: "logo",
    friendlyName: "Logo (below tiles)",
    type: "file",
    allowedFileTypes: ["svg", "png", "jpg", "jpeg", "webp"],
  },
  {
    name: "logoAlt",
    friendlyName: "Logo alt text",
    type: "string",
    defaultValue: "Caring Mill",
    showIf: `options.get('logo')`,
  },
  {
    name: "logoHref",
    friendlyName: "Logo link (optional)",
    type: "url",
    helperText: "Leave blank for no link.",
    showIf: `options.get('logo')`,
  },
  {
    name: "listName",
    friendlyName: "Analytics list name",
    type: "string",
    advanced: true,
    helperText: "GA4 item_list_name for tile clicks. Defaults to the headline.",
  },
];
